import quoteReducer from "./quote/reducer";

export default {
  quoteReducer,
};
